import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmModule } from '@app/shared/confirm/confirm.module';
import { CompanySelectDialogModule } from '@app/shared/company-select-dialog/company-select-dialog.module';
import { CableDialogComponent } from './cable-dialog.component';

@NgModule({
  declarations: [CableDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    TranslateModule,
    ConfirmModule,
    CompanySelectDialogModule,
  ],
  exports: [CableDialogComponent],
})
export class CableDialogModule {}
